// @flow
const configProd = {
  name: "configProd",
  baseName: "",
  oldDomainUrl: "https://zoom-ops.rivigo.com/#/",
  zoomApiUrl: "https://zoom-api.rivigo.com",
  loginUrl: "https://login.rivigo.com/sso/login?client_id=pace-ui",
  logoutUrl: "https://login.rivigo.com",
  ticketingApiUrl: "https://zoom-ticketing.rivigo.com",
  analyticsFlag: true,
  analyticsId: "UA-109460587-1",
  primeOpcApiUrl: "https://opc-api.rivigo.com"
};

export default configProd;



// WEBPACK FOOTER //
// ./app/configs/configProd.js